<app-splash-screen @fade *ngIf="isApp && !showPickright" [showLogo]="loadPickright"
  (logoReveled)="splashComplete($event)"></app-splash-screen>
<app-loader *ngIf="isAppLoading"></app-loader>
<div *ngIf="!isApp || showPickright" [@routeAnimations]="currentRouteIndex" [ngClass]="{'tw-hidden': isAppLoading}">
  <router-outlet #outlet="outlet" (activate)="onActivate(outlet)"></router-outlet>
</div>
<alert-message></alert-message>
<div aria-live="polite" aria-atomic="true" class="tw-sr-only" id="route-announcer">{{routeAnnouncement}}</div>
